import React from 'react';
import Chart from 'react-apexcharts';
export default function DummyLineChart() {
  const options = {
    chart: {
      toolbar: {
        show: false
      }
    },
    colors: ['#e6f1f8'],
    xaxis: {
      categories: ['0', '4', '8', '12', '16', '20', '24', '30'],
      labels: {
        show: false
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    stroke: {
      curve: 'smooth',
      width: 3,
      colors: '#e6f1f8'
    },
    yaxis: {
      show: false
    },
    grid: {
      show: false
    },
    tooltip: {
      enabled: false,
      theme: 'dark'
    }
  };
  const series = [{
    data: [5, 0, 12, 1, 8, 3, 12, 15]
  }];
  return /*#__PURE__*/React.createElement(Chart, {
    options: options,
    series: series,
    type: "line",
    height: "95"
  });
}